export class LikeComment {
    _id = '';
    target_link = '';
    reaction = Array();
    time_before_seeding_from = 2;
    time_before_seeding_to = 4;
    
    time_after_seeding_from = 2;
    time_after_seeding_to = 4;

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_models/auto_seeding/likeComment.ts